import AdminJudgingHome from './AdminJudgingHome';

export default AdminJudgingHome;
